import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import DropdownToggle from "@components/dropdown-toggle";
import Icon from "@components/icon";

import SubmenuDropdown from "../SubmenuDropdown";

import { useStore } from "../../../../connect";

import { popupWindowParams } from "../../../../consts";

import styles from "./SubmenuButton.scss";

const cx = classnames.bind(styles);

const SubmenuButton = ({
  isPopupLink,
  dropdownItems,
  href,
  newTab,
  children,
  icon,
  color,
  // counter,
  isFullWidth,
  popupName,
  dropdownId,
  onClick,
}) => {
  const { header } = useStore();

  const handleDropdownTriggerClick = () => {
    header.toggleDropdown(dropdownId);
  };

  const openPopup = (event) => {
    event.preventDefault();
    window.open(href, popupName, popupWindowParams);
  };

  const labelWithIcon = (
    <>
      {!!icon && (
        <Icon
          name={icon}
          size="s"
          stroke="var(--glz-color-neutral-tone-5)"
          color="transparent"
        />
      )}
      <span className={cx("label", { "label-with-arrow": !!dropdownItems })}>
        {children}
      </span>
      {/* {!!counter && <span>{counter}</span>} */}
    </>
  );

  if (dropdownItems) {
    const isDropdownOpen = header.openedDropdown === dropdownId;

    return (
      <DropdownToggle
        active={isDropdownOpen}
        onToggle={handleDropdownTriggerClick}
        classNames={{
          trigger: cx("submenu-button", `background-${color}`, {
            active: isDropdownOpen,
            "is-full-width": isFullWidth,
          }),
        }}
        dropdown={<SubmenuDropdown items={dropdownItems} />}
      >
        {labelWithIcon}
        <Icon
          name={isDropdownOpen ? "ic_arrow-up-out" : "ic_arrow-down-out"}
          size="s"
          color="var(--glz-color-neutral-tone-5)"
        />
      </DropdownToggle>
    );
  }

  if (!href && onClick) {
    return (
      <button
        className={cx("submenu-button", `background-${color}`, {
          "is-full-width": isFullWidth,
        })}
        onClick={onClick}
      >
        {labelWithIcon}
      </button>
    );
  }

  return (
    <a
      className={cx("submenu-button", `background-${color}`, {
        "is-full-width": isFullWidth,
      })}
      onClick={isPopupLink ? openPopup : onClick}
      href={href}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noopener noreferrer" : undefined}
    >
      {labelWithIcon}
    </a>
  );
};

SubmenuButton.propTypes = {
  isPopupLink: PropTypes.bool,
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.string,
      counter: PropTypes.node,
    })
  ),
  href: PropTypes.string,
  newTab: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.oneOf(["green", "yellow", "gray"]),
  // counter: PropTypes.node,
  isFullWidth: PropTypes.bool,
  popupName: PropTypes.string,
  dropdownId: PropTypes.string,
  onClick: PropTypes.func,
};

export default observer(SubmenuButton);
